export default __webpack_public_path__ + "036d1491fea867f4367e8b6586978adf.svg";